import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'

export const enum PageIdWoofzVgs {
  SEX_VGS = PageId.SEX_VGS,
  DOG_AGE_VGS = PageId.DOG_AGE_VGS,
  DOG_BREED_VGS = PageId.DOG_BREED_VGS,
  URGE_VGS = PageId.URGE_VGS,
  OTHER_DOGS_VGS = PageId.OTHER_DOGS_VGS,
  NOISES_VGS = PageId.NOISES_VGS,
  LEASH_PULLING_VGS = PageId.LEASH_PULLING_VGS,
  BARKS_VGS = PageId.BARKS_VGS,
  OUT_OF_CONTROL_VGS = PageId.OUT_OF_CONTROL_VGS,
  URGE_2_VGS = PageId.URGE_2_VGS,
  BEHAVIOR_VGS = PageId.BEHAVIOR_VGS,
  TRIGGERS_VGS = PageId.TRIGGERS_VGS,
  CALM_DOWN_VGS = PageId.CALM_DOWN_VGS,
  URGE_4_VGS = PageId.URGE_4_VGS,
  URGE_5_VGS = PageId.URGE_5_VGS,
  URGE_TOUCH = PageId.URGE_TOUCH,
  DOG_REACT_VGS = PageId.DOG_REACT_VGS,
  STRESSFUL_WALKS_VGS = PageId.STRESSFUL_WALKS_VGS,
  URGE_3_VGS = PageId.URGE_3_VGS,
  DOG_ACT_VGS = PageId.DOG_ACT_VGS,
  DOG_OFF_AT_HOME_VGS = PageId.DOG_OFF_AT_HOME_VGS,
  AGGRESSIVE_VGS = PageId.AGGRESSIVE_VGS,
  DOG_IGNORED_VGS = PageId.DOG_IGNORED_VGS,
  LOADER_SCREEN_VGS = PageId.LOADER_SCREEN_VGS,
  DOG_STATISTICS_VGS = PageId.DOG_STATISTICS_VGS,
  TIME_VGS = PageId.TIME_VGS,
  PREPARE_FLOW_VGS = PageId.PREPARE_FLOW_VGS,
  EMAIL_VGS = PageId.EMAIL_VGS,
  NEWSLETTER_VGS = PageId.NEWSLETTER_VGS,
  PERSONALIZED_PLAN_VGS = PageId.PERSONALIZED_PLAN_VGS,
  LAST_CHANCE_OFFER_VGS = PageId.LAST_CHANCE_OFFER_VGS,
  SUBSCRIPTIONS_VGS = PageId.SUBSCRIPTIONS_VGS,
  UPSELL_VGS = PageId.UPSELL_VGS,
  CHAT_UPSELL_VGS = PageId.CHAT_UPSELL_VGS,
  DOWNLOAD_VGS = PageId.DOWNLOAD_VGS,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}

type TIdToPageMapWoofzVgs = Record<PageIdWoofzVgs, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_VGS: TIdToPageMapWoofzVgs = {
  [PageIdWoofzVgs.SEX_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/DogSexQuestionVersion2'
      ).then((m) => ({
        default: m.DogSexQuestionVersion2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogSexQuestionVersion2'),
  },
  [PageIdWoofzVgs.DOG_AGE_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/DogAgeQuestionVersion2'
      ).then((m) => ({
        default: m.DogAgeQuestionVersion2,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogAgeQuestionVersion2'),
  },
  [PageIdWoofzVgs.DOG_BREED_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/dog-breed/DogBreedQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/dog-breed/DogBreedQuestion'
      ),
  },
  [PageIdWoofzVgs.URGE_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/urge/UrgePage'),
  },
  [PageIdWoofzVgs.OTHER_DOGS_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/WalkPastOtherDogsQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/WalkPastOtherDogsQuestion'
      ),
  },
  [PageIdWoofzVgs.NOISES_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/NoisesQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/NoisesQuestion'),
  },
  [PageIdWoofzVgs.LEASH_PULLING_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/LeashPullingQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/LeashPullingQuestion'),
  },
  [PageIdWoofzVgs.BARKS_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/BarksQuestion').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/BarksQuestion'),
  },
  [PageIdWoofzVgs.OUT_OF_CONTROL_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/OutOfControlQuestion'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/OutOfControlQuestion'),
  },
  [PageIdWoofzVgs.URGE_2_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant2'),
  },
  [PageIdWoofzVgs.BEHAVIOR_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/BehaviorQuestion').then(
        (m) => ({
          default: m.BehaviorQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/BehaviorQuestion'),
  },
  [PageIdWoofzVgs.TRIGGERS_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/TriggersQuestion').then(
        (m) => ({
          default: m.TriggersQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/TriggersQuestion'),
  },
  [PageIdWoofzVgs.CALM_DOWN_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogCalmDown').then(
        (m) => ({
          default: m.DogCalmDownQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogCalmDown'),
  },
  [PageIdWoofzVgs.DOG_REACT_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/DogReactionQuestion'
      ).then((m) => ({
        default: m.DogReactionQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogReactionQuestion'),
  },
  [PageIdWoofzVgs.STRESSFUL_WALKS_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/StressfulWalksQuestion'
      ).then((m) => ({
        default: m.StressfulWalksQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/StressfulWalksQuestion'),
  },
  [PageIdWoofzVgs.URGE_3_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant3'),
  },
  [PageIdWoofzVgs.URGE_4_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant4'),
  },
  [PageIdWoofzVgs.URGE_TOUCH]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgeTouch').then((m) => ({
        default: m.UrgeTouch,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/urge/UrgeTouch'),
  },
  [PageIdWoofzVgs.DOG_ACT_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogActQuestion').then(
        (m) => ({
          default: m.DogActQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogActQuestion'),
  },
  [PageIdWoofzVgs.DOG_OFF_AT_HOME_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/DogOffAtHomeQuestion'
      ).then((m) => ({
        default: m.DogOffAtHomeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogOffAtHomeQuestion'),
  },
  [PageIdWoofzVgs.AGGRESSIVE_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/DogAggressiveQuestion'
      ).then((m) => ({
        default: m.DogAggressiveQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogAggressiveQuestion'),
  },
  [PageIdWoofzVgs.DOG_IGNORED_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogIgnoredQuestion').then(
        (m) => ({
          default: m.DogIgnoredQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/DogIgnoredQuestion'),
  },
  [PageIdWoofzVgs.LOADER_SCREEN_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageLoader').then((m) => ({
        default: m.UrgePageLoader,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageLoader'),
  },
  [PageIdWoofzVgs.DOG_STATISTICS_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/dog-statistics/DogStatistics'
      ).then((m) => ({
        default: m.Component,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/dog-statistics/DogStatistics'
      ),
  },
  [PageIdWoofzVgs.TIME_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/questions/TimeQuestion').then(
        (m) => ({
          default: m.TimeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/TimeQuestion'),
  },
  [PageIdWoofzVgs.URGE_5_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/urge/UrgePageVariant5'),
  },
  [PageIdWoofzVgs.PREPARE_FLOW_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/questions/prepareFlow/PrepareFlow'
      ).then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/questions/prepareFlow/PrepareFlow'),
  },
  [PageIdWoofzVgs.EMAIL_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/email/EmailPage'),
  },
  [PageIdWoofzVgs.NEWSLETTER_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/email/NewsletterUrge').then(
        (m) => ({
          default: m.Component,
        }),
      ),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/email/NewsletterUrge'),
  },
  [PageIdWoofzVgs.PERSONALIZED_PLAN_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/urge/PersonalizedPlan').then(
        (m) => ({
          default: m.PersonalizedPlan,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/urge/PersonalizedPlan'),
  },
  [PageIdWoofzVgs.LAST_CHANCE_OFFER_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/last-chance-offer/LastChanceOfferScratch/LastChanceOfferScratchPage'
      ).then((m) => ({ default: m.LastChanceOfferScratchPage })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vgs/pages/last-chance-offer/LastChanceOfferScratch/LastChanceOfferScratchPage'
      ),
  },
  [PageIdWoofzVgs.SUBSCRIPTIONS_VGS]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vgs/pages/subscriptions/SubscriptionsPage'
      ).then((m) => ({
        default: m.SubscriptionsPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/subscriptions/SubscriptionsPage'),
  },
  [PageIdWoofzVgs.CHAT_UPSELL_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/upsell/ChatUpsellNewFlow').then(
        (m) => ({
          default: m.ChatUpsellNewFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/upsell/ChatUpsellNewFlow'),
  },
  [PageIdWoofzVgs.UPSELL_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz_vgs/pages/upsell/Upsell'),
  },
  [PageIdWoofzVgs.DOWNLOAD_VGS]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vgs/pages/download-app/DownloadApp').then(
        (m) => ({
          default: m.DownloadApp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vgs/pages/download-app/DownloadApp'),
  },
  [PageIdWoofzVgs.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
